import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { ServicePayload, UserServiceSessionExchangeDto } from '@nx-frontend/shared/types';

interface GetSessionExchangePayload extends Omit<ServicePayload, 'userId'> {
  token: string;
}

export async function getSessionExchange({
  host,
  token,
}: GetSessionExchangePayload): Promise<UserServiceSessionExchangeDto> {
  const response = await axiosClient.get<UserServiceSessionExchangeDto>(
    `${assertServiceHost(host)}/v1/sessionExchanges/${token}`
  );
  return response.data;
}
